<template>
  <div>
    <v-col cols="12" class="pt-0">
      <v-row>
        <v-col cols="3">
          <datePicker
            v-model="filtros.desde"
            format="YYYY-MM-DD"
            :maxDate="filtros.hasta"
            label="Desde (Obligatorio)"
            clearable
            maxToday
            @input="getOTS()"
            :disabled="cargando"
          ></datePicker>
        </v-col>
        <v-col cols="3">
          <datePicker
            v-model="filtros.hasta"
            format="YYYY-MM-DD"
            :minDate="filtros.desde"
            label="Hasta (Obligatorio)"
            clearable
            @input="getOTS()"
            :disabled="cargando"
          ></datePicker>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            v-model="filtros.idodt"
            :items="ots"
            item-value="idTrabajoOrden"
            item-text="clave"
            label="Orden de Trabajo (Obligatorio)"
            hide-details
            :disabled="loadingots || ots.length == 0"
            :loading="loadingots"
            @change="getData()"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            color="primary"
            :disabled="disabledBtnRefresh"
            @click="getData()"
          >
            <v-icon left>mdi-refresh</v-icon> Refrescar
          </v-btn>
        </v-col>
        <v-col cols="12" md="12" sm="12">
          <v-row class="d-flex justify-center">
            <v-col cols="12" md="3" sm="12">
              <v-card class="fill-height d-flex">
                <v-card-text class="text-center align-self-center">
                  <div class="subtitle-1 font-weight-bold">
                    Kilogramos Usados
                  </div>
                  <!-- :endVal="estadisticas.montoTotalEstimadoProduccion" -->
                  <ICountUp
                    v-if="loadingEstadisticas"
                    :delay="1000"
                    :endVal="this.apex.kgUtilizados"
                    class="subtitle-1 font-weight-medium"
                    :options="{
                      decimalPlaces: 2,
                      separator: ',',
                      decimal: '.',
                      prefix: '',
                    }"
                  />
                  <div v-else class="text-center">
                    <v-progress-circular
                      :size="25"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <v-card class="fill-height d-flex">
                <v-card-text class="text-center align-self-center">
                  <div class="subtitle-1 font-weight-bold">
                    Cantidad de Laminas
                  </div>
                  <!-- :endVal="estadisticas.montoTotalEstimadoProduccion" -->
                  <ICountUp
                    v-if="loadingEstadisticas"
                    :delay="1000"
                    :endVal="this.apex.cantidadLaminas"
                    class="subtitle-1 font-weight-medium"
                    :options="{
                      decimalPlaces: 2,
                      separator: ',',
                      decimal: '.',
                      prefix: '',
                    }"
                  />
                  <div v-else class="text-center">
                    <v-progress-circular
                      :size="25"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <v-card class="fill-height d-flex">
                <v-card-text class="text-center align-self-center">
                  <div class="subtitle-1 font-weight-bold">
                    Piezas Fabricadas
                  </div>
                  <ICountUp
                    v-if="loadingEstadisticas"
                    :delay="1000"
                    :endVal="this.apex.pzaFabricadas"
                    class="subtitle-1 font-weight-medium"
                    :options="{
                      decimalPlaces: 2,
                      separator: ',',
                      decimal: '.',
                      prefix: '',
                    }"
                  />
                  <div v-else class="text-center">
                    <v-progress-circular
                      :size="25"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" sm="12" v-if="cargando">
          <v-progress-linear
            color="primary"
            height="5"
            indeterminate
          ></v-progress-linear>
        </v-col>
        <v-col v-else cols="12" md="12" sm="12">
          <!-- <apexchart
            type="bar"
            height="350"
            :options="chartOptions"
            :series="series"
          ></apexchart> -->
          <apexchart
            type="bar"
            height="500"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-simple-table v-if="items.length >0">
        <thead>
          <tr>
            <th class="text-center" style="min-width: 100px;">
              <div class="d-flex flex-column align-items-center">
              <th class="text-center text-subtitle-1" style="white-space: nowrap;">Receta</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[0], 0)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
              </div>
            </th>
            <th class="text-center" style="min-width: 100px;">
              <div class="d-flex flex-column align-items-center">
              <th class="text-center text-subtitle-1" style="white-space: nowrap;">Salida De Almacén</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[1], 0)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
                </div>
            </th>
            <th v-for="(item, index) in headers.slice(2)" :key="index" class="text-center" style="min-width: 700px;">
              <span class="text-h6">{{ item.text }}</span>
              <div class="subheaders">
                <div class="d-flex flex-column align-items-center">
                  <th class="text-center text-subtitle-1 mx-3" style="white-space: nowrap;">M.P. Teórica</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[index + 2], 3)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
                </div>
                <div class="d-flex flex-column align-items-center">
                  <th class="text-center text-subtitle-1 mx-3" style="white-space: nowrap;">M.P. Real</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[index + 2], 2)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
                </div>
                <div class="d-flex flex-column align-items-center">
                  <th class="text-center text-subtitle-1 mx-3" style="white-space: nowrap;">Merma Teórica</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[index + 2], 1)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
                </div>
                <div class="d-flex flex-column align-items-center">
                  <th class="text-center text-subtitle-1 mx-3" style="white-space: nowrap;">Merma Real</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[index + 2], 0)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
                </div>
                <div class="d-flex flex-column align-items-center">
                  <th class="text-center text-subtitle-1 mx-3" style="white-space: nowrap;">Scrap Teórico</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[index + 2], 5)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 
                  </th>
                </div>
                <div class="d-flex flex-column align-items-center">
                  <th class="text-center text-subtitle-1 mx-3" style="white-space: nowrap;">Scrap Real</th>
                  <th class="text-center">
                    {{ (Number(valueData(items[index + 2], 4)).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  </th>
                </div>
              </div>
            </th>
          </tr>
        </thead>
      </v-simple-table>
    </v-col>
  </div>
</template>
  
  <script>
import axios from "axios";
import ICountUp from "vue-countup-v2";
/* 
  import { mapState } from "vuex"; */
/* import DownloadBtn from "../../../DownloadBtn.vue"; */

export default {
  components: {
    ICountUp,
  },
  data() {
    return {
      loadingEstadisticas: true,
      cargando: false,
      filtros: {
        idodt: null,
        desde: null,
        hasta: null,
      },
      ots: [],
      categories: [],
      series: [],
      loadingMaquinas: false,
      loadingots: false,
      apex: {
        kgUtilizados: 0,
        cantidadLaminas: 0,
        pzaFabricadas: 0,
      },
      colors: [
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#FF4560',
        '#775DD0',
        '#546E7A',
        '#26a69a',
        '#D10CE8'
      ],

      headers: [],
      items: [],
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    disabledBtnRefresh(){
      return this.cargando || Object.values(this.filtros).some(value => value == null);
    },
    chartOptions() {
      return {
        colors: this.colors,
        states: {
          active: {
            allowMultipleDataPointsSelection: false,
          },
        },
        chart: {
          type: "bar",
          height: 500,
          barWidth: '10',
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "100%",
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return val.toFixed(2)+' Kg';
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.categories,
           labels: {
            maxHeight: 200,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+' Kg';
            }
          }
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toFixed(2)+' Kg';
            },
          },
        },
      };
    },
  },
  methods: {
    initialize() {
      this.getOTS();
      this.getData();
    },
    getOTS() {
      this.headers = [];
      this.items = [];
      if (this.filtros.desde == null || this.filtros.hasta == null) return;

      this.loadingots = true;
      var url = `/TrabajoOrdenes/TrabajoOrdenHeaders?soloEnProgreso=false&desde=${this.filtros.desde}&hasta=${this.filtros.hasta}`;

      axios
        .get(url)
        .then((response) => {
          this.ots = response.data;
          this.loadingots = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingots = false;
        });
    },
    getData() {
      if (this.filtros.idodt == null) return;

      var url = `/Reportes/ReporteProduccionProceso/${this.filtros.idodt}?`;

      if (this.filtros.desde != null)
        url += `&fechaInicio=${this.filtros.desde}`;
      if (this.filtros.hasta != null) url += `&fechaFin=${this.filtros.hasta}`;

      this.cargando = true;
      this.loadingEstadisticas = false;
      axios
        .get(url)
        .then((response) => {
          this.series = response.data.series;
          this.categories = response.data.categorias;
          this.apex.kgUtilizados = response.data.kgUtilizados;
          this.apex.cantidadLaminas = response.data.cantidadLaminas;
          this.apex.pzaFabricadas = response.data.pzaFabricadas;

          this.cargando = false;
          this.loadingEstadisticas = true;

          let dataTable = response.data.seriesGeneral;
          let categoriasTable = response.data.categorias;
          let seriesTable = response.data.series;
          this.tableGenerate(dataTable, categoriasTable, seriesTable);
        })
        .catch((error) => {
          console.log(error);
          this.cargando = false;
          this.loadingEstadisticas = true;
        })
      },

    tableGenerate(dataTable, categoriasTable, seriesTable) {
      let newHeaders = [];
      let otherHeaders = [];
      let newData = [];
      let otherData = [];

      dataTable.forEach(element => {
        newHeaders.push({
          text: element.nombre,
          value: element.nombre.toLowerCase().replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => index === 0 ? match.toLowerCase() : match.toUpperCase()).replace(/\s+/g, ''),
          align: "center",
          sortable: false,
        });

        newData.push( {
          mermaReal: element.mermaReal,
          mermaTeorico: element.mermaTeorico,
          mpReal: element.mpReal,
          mpTeorico: element.mpTeorico,
          scrapReal: element.scrapReal,
          scrapTeorico: element.scrapTeorico,
        })
      });

      for(let i = 0; i < 2; i++) {
        otherHeaders.push({
          text: categoriasTable[i],
          value: categoriasTable[i].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => index === 0 ? match.toLowerCase() : match.toUpperCase()).replace(/\s+/g, ''),
          align: "center",
          sortable: false,
        });
        
        otherData.push({
          sumFirstColumn: seriesTable.reduce((sum, item) => sum + item.data[i], 0),
        });
      }

      // let totalHeaders = otherHeaders.concat(newHeaders);
      let totalData = otherData.concat(newData);
      
      // this.updateItems(totalData);
      this.items = totalData;
      // this.updateHeaders(totalHeaders);
      // this.headers = totalHeaders;
      this.headers = [...otherHeaders, ...newHeaders];
      console.log(this.headers)
    },
    valueData(item, idx){
      let valores = Object.values(item);
      return valores[idx]
    },
  },
};
</script>

<style>
.subheaders {
  display: flex;
  justify-content: space-evenly;
  margin-top: 5px;
}

.subheader {
  text-align: center;
  font-size: 12px;
  margin: 0 80px 0 80px;
  color: #616161;
}
</style>